// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleBylines_root__CFgKs","link":"ArticleBylines_link__IlZu4"};